/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  var lastScrollTop = 0;
  var ignore_scroll_watch = false;

  function watchNavigationScroll(e) {
    if( ignore_scroll_watch ) {
      return;
    }

    var st = $(window).scrollTop();

    if (e && e.type && e.type === "scroll") {
      if (st > lastScrollTop) {
        $('body').addClass('scrolled-down');
        $('body').removeClass('scrolled-up');
      }
      else {
        $('body').removeClass('scrolled-down');
        $('body').addClass('scrolled-up');
      }

      lastScrollTop = st <= 0 ? 0 : st;
    }

    if (st > 50) {
      $('body').addClass('scrolled');
    }
    else {
      $('body').removeClass('scrolled');
    }
  }

  function watchSlickDots() {
    setTimeout(function() {
      $('.slick-dots').each(function() {
        $(this).attr('data-dots-count', $(this).find('li').length);
      });
    }, 300);
  }

  jQuery.extend({
    isValidSelector: function(selector) {
      if (typeof(selector) !== 'string') {
        return false;
      }
      try {
        var $element = $(selector);
      } catch(error) {
        return false;
      }
      return true;
    }
  });

  function appHeight() {
    var doc = document.documentElement;
    doc.style.setProperty('--vh', (window.innerHeight*0.01) + 'px');
  }

  window.addEventListener('resize', appHeight);
  appHeight();


  function formToUrlLeadership() {
    var formData = new FormData(document.querySelector(".leadership-sidebar-filters"));
    var formParams = new URLSearchParams(formData);
    const paramsToDelete = ['_wp_http_referer', 'action', 'insightsnonce', 'page'];

    paramsToDelete.forEach(function(value) {
      formParams.delete(value);
    });

    formParams.forEach(function(value, key) {
      if (value == "") {
        formParams.delete(key);
      }
    });

    var formStr = formParams.toString();
    if( formStr.trim().length > 0 ) {
      var nextURL = window.location.origin + window.location.pathname + "?" + formStr;
      var nextTitle = 'Filtered Leadership';
      var nextState = { additionalInformation: 'Filtered Leadership' };
      window.history.replaceState(nextState, nextTitle, nextURL);
    }else if(window.location.search.length > 0){
      var nextURL = window.location.origin + window.location.pathname;
      var nextTitle = 'Filtered Leadership';
      var nextState = { additionalInformation: 'Filtered Leadership' };
      window.history.replaceState(nextState, nextTitle, nextURL);
    }
  }

  function submitInsightsFilter() {
    var form = $('.insights-sidebar-filters');
    var insights_list = $('.insights-content .insights-list');
    var no_results_text = $('.insights-content .no-results-text');
    var pagination = $('.insights-content .posts-pagination');

    var formData = new FormData(document.querySelector(".insights-sidebar-filters"));
    var formParams = new URLSearchParams(formData);

    const paramsToDelete = ['_wp_http_referer', 'action', 'insightsnonce', 'page'];

    paramsToDelete.forEach(function(value) {
      formParams.delete(value);
    });

    var t = $('.dates-slider-wrapper');
    var range = t.attr('data-range').split('|');
    var selectedDates = t.val().split(';');
    if( selectedDates[0] == range[0] && selectedDates[1] == range[ range.length - 1 ] ) {
      formParams.delete('date-range');
    }

    formParams.forEach(function(value, key) {
      if (value == "") {
        formParams.delete(key);
      }
    });

    var formStr = formParams.toString();
    if( formStr.trim().length > 0 ) {
      var nextURL = window.location.origin + window.location.pathname + "?" + formStr;
      var nextTitle = 'Filtered Insights';
      var nextState = { additionalInformation: 'Filtered Insights' };
      window.history.replaceState(nextState, nextTitle, nextURL);
    }else if(window.location.search.length > 0){
      var nextURL = window.location.origin + window.location.pathname;
      var nextTitle = 'Filtered Insights';
      var nextState = { additionalInformation: 'Filtered Insights' };
      window.history.replaceState(nextState, nextTitle, nextURL);
    }

    if( $('#blog-page-content').hasClass('loading') ) {
      return false;
    }

    $.ajax({
      type : 'POST',
      url : js_vars.ajaxurl,
      data : form.serialize(),
      beforeSend: function() {
        $('#blog-page-content').addClass('loading');
      },
      success : function(data, status, request){
        if(data.insights) {
          insights_list.html( data.insights );
          no_results_text.hide();
        }
        else {
          insights_list.empty();
          no_results_text.show();
        }

        if( data.pagination ) {
          pagination.html( data.pagination ).show();
        }
        else {
          pagination.empty().hide();
        }

        $('html').addClass('regular-scroll');
        $('body').addClass('scrolled-down').removeClass('scrolled-up');
        ignore_scroll_watch = true;

        $('html,body').stop().animate({
          scrollTop: $('#blog-page-content .insights-content').offset().top
        }, 500);

        setTimeout(function() {
          $('html').removeClass('regular-scroll');
          ignore_scroll_watch = false;
        }, 1000);
      },
      complete: function(){
        $('#blog-page-content').removeClass('loading');
      },
      dataType : 'JSON'
    });
  }

  function submitLeadershipFilter() {
    var section = $('.section-leadership');
    
    if( section.find('.filter-category input[type="checkbox"]:checked').length ) {
      var something_found = false;

      section.find('.leadership-grid article').each(function() {
        var match = true;
        var item = $(this);

        section.find('.filter-category').each(function() {
          var category = $(this);
          var fc = category.find('.category-terms').attr('data-category');

          if( match && category.find('input[type="checkbox"]:checked').length ) {
            var match_this_section = false;

            section.find('input[type="checkbox"]:checked').each(function() {
              var val = 'filter-' + fc + '-' + $(this).val();
              
              if( !match_this_section && item.hasClass( val ) ) {//check for the next checked item
                match_this_section = true;
              }
            });

            if( !match_this_section ) {
              match = false;
            }
          }
        });

        if( match ) {
          something_found = true;

          item.show();
        }
        else {
          item.hide();
        }
      });

      if( something_found ) {
        section.find('.no-results-text').hide();
      }
      else {
        section.find('.no-results-text').show();
      }
    }
    else {
      section.find('.leadership-grid article').show();

      section.find('.no-results-text').hide();
    }

    $('html').addClass('regular-scroll');
    $('body').addClass('scrolled-down').removeClass('scrolled-up');
    ignore_scroll_watch = true;

    $('html,body').stop().animate({
      scrollTop: section.find('.leadership-column').offset().top
    }, 500);

    setTimeout(function() {
      $('html').removeClass('regular-scroll');
      ignore_scroll_watch = false;
    }, 1000);
  }






  function isEmptyElm(elm){
    return (elm != null && elm !== false && elm !== "");
  }
  
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        watchNavigationScroll();

        $(window).on('load resize scroll orientationchange', function (e) {
          watchNavigationScroll(e);
        });

        $('body').addClass('dom-loaded');

        var scrollbarSize = 0;

        var scrollDiv = document.createElement("div");
        scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
        document.body.appendChild(scrollDiv);
        scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);

        style = document.createElement("style");
        style.textContent = "html.side-menu-on, html.mobile-menu-on { margin-right: "+scrollbarSize+"px; }";
        document.head.appendChild(style);

        $(document).on('focus', 'select', function() {
          $(this).closest('div').addClass('active-select');
        });

        $(document).on('blur', 'select', function() {
          $(this).closest('div').removeClass('active-select');
        });

        $(document).on('click', '#navigation .dropdown-toggle', function(e) {
          e.preventDefault();

          if( $('#header .navbar-toggler').is(':visible') ) {
            var sub_menu = $(this).next('.sub-menu-wrap');

            if( sub_menu.length ) {
              if( sub_menu.is(':visible') ) {
                $(this).removeClass('open');
                sub_menu.slideUp('fast');
              }
              else {
                $(this).addClass('open');
                sub_menu.slideDown('fast');
              }
            }
          }
        });

        var wow = new WOW(
          {
            boxClass: 'wow',      // animated element css class (default is wow)
            animateClass: 'animated', // animation css class (default is animated)
            offset: 70,          // distance to the element when triggering the animation (default is 0)
            mobile: true,       // trigger animations on mobile devices (default is true)
            live: true,       // act on asynchronously loaded content (default is true)
            callback: function (box) {
              $(box).addClass('appeared');
            },
            scrollContainer: null // optional scroll container selector, otherwise use window
          }
        );
        wow.init();

        $('.section-related-industries .industries-carousel').each(function() {
          var t = $(this);

          t.slick({
            autoplay: false,
            dots: false,
            arrows: true,
            appendArrows: t.closest('section').find('.carousel-controls'),
            variableWidth: true
          });
        });

        $('.section-related-insights .insights-carousel').each(function() {
          var t = $(this);

          t.slick({
            autoplay: false,
            infinite:t.hasClass('infinite'),
            dots: false,
            arrows: true,
            appendArrows: t.closest('section').find('.carousel-controls'),
            variableWidth: true
          });
        });

        $(document).on('click', '.section-leadership .filter-category input[type="checkbox"]', function() {
          submitLeadershipFilter();
          formToUrlLeadership();
          /*
          var t = $(this);
          var section = t.closest('section');
          
          if( section.find('.filter-category input[type="checkbox"]:checked').length ) {
            var something_found = false;

            section.find('.leadership-grid article').each(function() {
              var match = true;
              var item = $(this);

              section.find('.filter-category').each(function() {
                var category = $(this);
                var fc = category.find('.category-terms').attr('data-category');

                if( match && category.find('input[type="checkbox"]:checked').length ) {
                  var match_this_section = false;

                  section.find('input[type="checkbox"]:checked').each(function() {
                    var val = 'filter-' + fc + '-' + $(this).val();
                    
                    if( !match_this_section && item.hasClass( val ) ) {//check for the next checked item
                      match_this_section = true;
                    }
                  });

                  if( !match_this_section ) {
                    match = false;
                  }
                }
              });

              if( match ) {
                something_found = true;

                item.show();
              }
              else {
                item.hide();
              }
            });

            if( something_found ) {
              section.find('.no-results-text').hide();
            }
            else {
              section.find('.no-results-text').show();
            }
          }
          else {
            section.find('.leadership-grid article').show();

            section.find('.no-results-text').hide();
          }

          $('html').addClass('regular-scroll');
          $('body').addClass('scrolled-down').removeClass('scrolled-up');
          ignore_scroll_watch = true;

          $('html,body').stop().animate({
            scrollTop: section.find('.leadership-column').offset().top
          }, 500);

          setTimeout(function() {
            $('html').removeClass('regular-scroll');
            ignore_scroll_watch = false;
          }, 1000);
          */
        });

        $(document).on('change', '.insights-sidebar-filters select, .insights-sidebar-filters input:not([type="checkbox"]):not([type="radio"]):not(.dates-slider-wrapper)', function() {
          submitInsightsFilter();
        });

        $(document).on('click', '.insights-sidebar-filters input[type="checkbox"], .insights-sidebar-filters input[type="radio"]', function() {
          submitInsightsFilter();
        });

        $(document).on('click', '.insights-content .posts-pagination a', function(e) {
          e.preventDefault();

          var parts = $(this).attr('href').split('/').filter( isEmptyElm );

          if( parts.length ) {
            page = parts[ parts.length - 1 ];
            
            $('.insights-sidebar-filters input[name="page"]').val( page );
            
            submitInsightsFilter();
          }
        });

        $(document).on('submit', '.insights-sidebar-filters', function(e) {
          e.preventDefault();

          submitInsightsFilter();

          return false;
        });

        $('.dates-slider-wrapper').each(function() {
          var t = $(this);

          var range = t.attr('data-range').split('|');
          var earliest = t.attr('data-earliest');
          var earliest_key = range.indexOf( earliest );
          var latest = t.attr('data-latest');
          var latest_key = range.indexOf( latest );

          t.data('dates_range', range);

          /*
          t.ionRangeSlider({
            type: "double",
            values: range,
            from: range[0],
            to: range[ range.length - 1 ],
            hide_min_max: true,
            onFinish: submitInsightsFilter
          });

          */
          t.ionRangeSlider({
            type: "double",
            values: range,
            from: earliest_key,
            to: latest_key,
            hide_min_max: true,
            onFinish: submitInsightsFilter
          });



          t.on('change', function() {
            t.siblings('.dates-slider-values').text( t.val().replace(';', ' - ') );
          });
        });

        $(document).on('click', '.insights-sidebar .sidebar-blue-box a[href="#newsletter-signup"]', function(e) {
          e.preventDefault();

          var t = $(this);

          new bootstrap.Modal( $('#newsletter-signup') ).show();
        });

        $(document).on('click', '.side-menu .mg-links > li.open-secondary-level-links > a', function(e) {
          e.preventDefault();

          var li = $(this).closest('li');
          var target = li.attr('data-sl-target');

          if( $.isValidSelector( target ) ) {
            target = $( target );

            if( target.length ) {
              $('.side-menu .mg-links > li').removeClass('active');
              li.addClass('active');

              $('.secondary-level-links').removeClass('on');
              target.addClass('on');
            }
          }
        });

        $(document).on('click', 'li.side-menu-opener > a', function(e) {
          e.preventDefault();

          var t = $(this);
          var target = t.attr('href');

          if( $.isValidSelector( target ) ) {
            target = $( target );

            if( target.length ) {
              $('html').addClass('side-menu-on');
              $('.side-menu').removeClass('on');
              target.addClass('on');
            }
          }
        });

        $(document).on('click', '.side-menu .menu-header .side-menu-close:not(.close-all)', function(e) {
          e.preventDefault();

          $('html').removeClass('side-menu-on');
          $('html').removeClass('mobile-menu-on');
          $('.side-menu').removeClass('on');

          $('.side-menu .mg-links > li').removeClass('active');
          $('.secondary-level-links').removeClass('on');
        });

        $(document).on('click', '#side-nav-backgdrop', function(e) {
          if( $('html').hasClass('side-menu-on') ) {
            $('.side-menu .menu-header .side-menu-close:not(.close-all)').eq(0).click();
          }
        });

        $(document).keyup(function(e) {
          if (e.keyCode === 27) {
            if( $('html').hasClass('side-menu-on') ) {
              $('.side-menu .menu-header .side-menu-close:not(.close-all)').eq(0).click();
            }
          }
        });

        $(document).on('click', '.side-menu-close.close-all', function(e) {
          e.preventDefault();

          $('html').removeClass('side-menu-on');
          $('html').removeClass('mobile-menu-on');

          $('#mobile-navigation').removeClass('on');
          $('.side-menu .mg-links > li').removeClass('active');
          $('.side-menu').removeClass('on');
          $('.secondary-level-links').removeClass('on');
        });

        $(document).on('click', '.mobile-menu-show', function(e) {
          e.preventDefault();

          $('html').addClass('mobile-menu-on');
          $('#mobile-navigation').addClass('on');
        });

        $(document).on('click', '.mobile-menu-close', function(e) {
          e.preventDefault();

          $('html').removeClass('mobile-menu-on');
          $('#mobile-navigation').removeClass('on');
        });

        $(document).on('click', '.sl-back-link', function(e) {
          e.preventDefault();

          $(this).closest('.secondary-level-links').removeClass('on');
          $('.side-menu .mg-links > li').removeClass('active');
        });

        $(document).on('click', '.filter-wrapper-toggle', function(e) {
          e.preventDefault();

          if( $(this).hasClass('expanded') ) {
            $(this).removeClass('expanded').siblings('.filters-wrapper-inner').slideUp('slow');
          }
          else {
            $(this).addClass('expanded').siblings('.filters-wrapper-inner').slideDown('slow');
          }
        });

        $(document).on('mouseenter', '.section-related-services .service-item a', function() {
          var t = $(this);
          var section = t.closest('section');
          var idx = t.closest('.service-item').attr('data-idx');

          $('.service-background-image').removeClass('on');
          section.find('.service-background-image[data-idx="'+idx+'"]').addClass('on');
        });

        $(document).on('mouseleave', '.section-related-services .services-column', function() {
          $('.service-background-image').removeClass('on');
        });

        $('.modal').appendTo('body');

        watchSlickDots();

        $(window).on('resize', function() {
          watchSlickDots();
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');

      if(window.location.search.length > 0){
        if(window.location.href.includes('insights')){
          submitInsightsFilter();
        }
        if(window.location.href.includes('leadership')){
          submitLeadershipFilter();
        }

      }
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
